import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';

const ZERO_STATE_BENEFITS = [
  {
    icon: <TaskOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'ldZsBenefit1',
  },
  {
    icon: (
      <EventAvailableOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />
    ),
    description: 'ldZsBenefit2',
  },
  {
    icon: <LanguageOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'ldZsBenefit3',
  },
  {
    icon: (
      <SentimentSatisfiedAltOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />
    ),
    description: 'ldZsBenefit4',
  },
];

export default ZERO_STATE_BENEFITS;
